<template>
  <div class="mb-5 order-item-container" style="border: 1px solid #e7e7e7;">
    <div style="background: #e7e7e7; padding: 6px 20px;">
      {{ $i18n.t("order.Order number") }}
    </div>
    <div
      class="d-flex justify-space-between align-center"
      style="margin: 0 20px;"
    >
      <div style="width: 55%;">
        <div class="my-2">
          {{ $i18n.t("order.Type of purchase") }}:
          {{ $i18n.t(`order.${order.subject}`) }}
        </div>
        <div class="my-2">
          {{ $i18n.t("order.Authorized time") }}:
          <span v-if="order.body === '60'">{{
            $i18n.t("author.all life")
          }}</span>
          <span v-if="order.body === '1'"
            >{{ order.body }}{{ $i18n.t("order.year") }}</span
          >
          <span v-if="order.body !== '1' && order.body !== '60'"
            >{{ order.body }}{{ $i18n.t("order.years") }}</span
          >
        </div>
        <div class="my-2">
          {{ $i18n.t("order.Order creation time") }}:
          {{ order.createDate }}
        </div>
      </div>
      <div style="width: 15%; text-align: center;">
        ￥{{ order.totalAmount }}
      </div>
      <div style="width: 15%; text-align: center;">
        {{
          order.status === "TRADE_SUCCESS"
            ? $i18n.t("order.success")
            : $i18n.t("order.tobepaid")
        }}
      </div>
      <div
        v-if="order.isInvoiced === 'no'"
        class="common-font-color"
        @click="changeOrder(order)"
        style="width: 15%; text-align: right;"
      >
        {{ $i18n.t("order.Invoicing") }}
      </div>
      <div
        v-if="order.isInvoiced === 'yes'"
        class="common-font-black-normal"
        style="width: 15%; text-align: right;"
      >
        {{ $i18n.t("order.Invoiced") }}
      </div>
      <div
        v-if="order.isInvoiced === 'unsupport'"
        class="common-font-black-normal"
        style="width: 15%; text-align: right;"
      >
        {{ $i18n.t("order.Unable to invoice") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderItem",
  props: {
    order: Object,
  },
  methods: {
    changeOrder(order) {
      this.$emit("changeShowOrder", order);
    },
  },
};
</script>

<style scoped></style>
